<template>
  <v-card>
    <v-card-title>Project Details</v-card-title>
    <v-divider></v-divider>
    <v-card-text style="height: 390px;">
      <v-row>
        <v-col cols="4">
          <v-text-field label="Project ID" v-model="item.projectID"></v-text-field>
        </v-col>
        <v-col cols="8">
          <v-select :items="statuses" label="Status" v-model="item.status"></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-select
            multiple
            outlined
            dense
            :items="types"
            label="Project Type(s)"
            v-model="item.types"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <AADate
            clearable
            label="Enquiry Date"
            :date="item.dateEnquiry"
            v-on:date-changed="item.dateEnquiry = $event"
          />
        </v-col>

        <v-col cols="6">
          <AADate
            clearable
            label="Proposal Date"
            :date="item.dateProposal"
            v-on:date-changed="item.dateProposal = $event"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <AADate
            clearable
            label="Accepted Date"
            :date="item.dateAccepted"
            v-on:date-changed="item.dateAccepted = $event"
          />
        </v-col>

        <v-col cols="6">
          <AADate
            clearable
            label="Start Date"
            :date="item.dateStarted"
            v-on:date-changed="item.dateStarted = $event"
          />
        </v-col>

        <v-col cols="12" class="mt-n2">
          <v-textarea label="Note" clearable rows="4" class="mt-n1" v-model="item.note"></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="obj.update(obj.item)">Save</v-btn>
      <v-btn color="green darken-1" text @click="obj.close()">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AADate from "@/components/AADate";
import { storeprops } from "@/store/helpers.js";
export default {
  components: { AADate },
  props: {
    obj: Object
  },
  computed: {
    ...storeprops,
    item() {
      return this.obj.item;
    },
    statuses() {
      return this.$store.getters.statuses;
    },
    types() {
      return this.$store.getters.types;
    }
  },
  data: () => {
    return {
      active: false,
      model: 1
    };
  },
  methods: {
    // selectClient() {
    //   let client = this.filteredClients[this.model];
    //   this.obj.select(client);
    // }
  }
};
</script>

<style scoped>
</style>
